import type { HskVersionKey } from "#hsk-grade-word-lists";

export function pickHskLevel(
  grapheme: {
    hsk2010Level: number | null;
    hsk2021Level: number | null;
    hsk2026Level: number | null;
  },
  hskVersion: HskVersionKey,
): number | null {
  switch (hskVersion) {
    case "hsk2": {
      return grapheme.hsk2010Level ?? null;
    }
    case "hsk3": {
      return grapheme.hsk2021Level ?? null;
    }
    case "hsk2026": {
      return grapheme.hsk2026Level ?? null;
    }
  }
}
